export enum ChangeProjectStateType {
  Archive = 'archive',
  UnAarchive = 'unarchive',
  Activate = 'activate',
  Deactivate = 'deactivate'
}
